export default __webpack_public_path__ + "static/media/ASR-BNB.8d25d537.svg";